const _ = require('lodash');
const {
	NATIVE_FIELDS,
	NATIVE_IMAGE_FIELDS,
} = require('./native');
const { versionGte } = require('../misc/misc');
const TagUtils = require('../misc/tagUtils');
const { splitParams, unRlvPrefix } = require('./bidParamUtils');
const { PrebidDataObjects } = require('./prebidDataObjects');

// Fields in adUnit.nativeSettings that should *not* go into mediaTypes.native
const infoKeys = _.filter(PrebidDataObjects.nativeSettings.getTagFields(), 'isNativeInfo')
	.map(({ name }) => unRlvPrefix(name));

/** Content in this file should not be included in tag-file in order to save space */

const finalizeNativeSettings = (settings, pbjsVersion) => {
	const { normal, internal } = splitParams(settings);
	const {
		nativeMode, adTemplate, rendererUrl, sendTargetingKeys, ortbMode, ortb,
	} = internal;
	const rlvInfo = _.pick(internal, infoKeys);
	if (!nativeMode || nativeMode === 'disabled') {
		return undefined;
	}
	const useOrtb = ['legacyOrtb', 'ortb'].includes(ortbMode);
	const finalRes = {};
	NATIVE_FIELDS.forEach((fld) => {
		const obj = internal[fld] || {};
		const res = {};
		['required', 'disabled'].forEach((name) => {
			if (obj[name]) {
				res[name] = obj[name];
			}
		});
		if (NATIVE_IMAGE_FIELDS.includes(fld)) {
			if (obj.width && obj.height) {
				if (obj.useAspec) {
					res.aspect_ratios = [{
						min_width: obj.width,
						min_height: obj.height,
						ratio_width: obj.width,
						ratio_height: obj.height,
					}];
				} else {
					res.sizes = [obj.width, obj.height];
				}
			}
		} else if (obj.length) {
			res.len = obj.length;
		}
		if (Object.keys(res).length) {
			finalRes[fld] = res;
		}
	});
	const { ortb: userOrtb, ...userParams } = normal;
	const adjustedOrtb	= TagUtils.mergeNoArr(
		_.mapValues(ortb, (v) => (_.isString(v) ? parseInt(v, 10) : v)), // options are numbers-as-strings
		userOrtb,
	);
	return {
		nativeSettings: TagUtils.mergeNoArr({
			...finalRes,
			...(!versionGte(pbjsVersion, '9') && { sendTargetingKeys }), // Don't set in pbjs 9+
			adTemplate: (adTemplate || '').trim().length ? adTemplate : undefined,
			rendererUrl: rendererUrl || undefined,
			...(useOrtb && { [ortbMode]: adjustedOrtb }),
			...(!_.isEmpty(rlvInfo) && { rlvInfo }),
		}, userParams),
		internal,
	};
};

module.exports = {
	finalizeNativeSettings,
};
